import PropTypes from "prop-types";
import classNames from "classnames";

import Spinner from "~/components/shared/Spinner";
import Icon from "~/components/shared/Icon";

import Option from "~/components/shared/Chooser/option";

function SelectOption(props) {
  return (
    <Option
      value={props.value}
      className={classNames("btn hover-bg-silver block", {
        "bg-silver": props.selected,
      })}
    >
      <div className="items-top flex">
        <div className="flex-none">
          <SelectIcon saving={props.saving} selected={props.selected} />
        </div>
        <div>
          <span className="semi-bold block">{props.label}</span>
          <small className="dark-gray font-normal">{props.description}</small>
        </div>
      </div>
    </Option>
  );
}

SelectOption.displayName = "Chooser.SelectOption";

SelectOption.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.node.isRequired,
  saving: PropTypes.bool,
  selected: PropTypes.bool,
};

function SelectIcon(props) {
  const size = 25;

  if (props.saving) {
    return (
      <div className="relative inline-block" style={{ width: size, height: size }}>
        <Spinner className="absolute max-w-full" size={16} color={false} style={{ left: 3 }} />
      </div>
    );
  }

  const tickColor = props.selected ? "green" : "dark-gray";

  return (
    <Icon
      icon="permission-small-tick"
      className={classNames(tickColor, "relative")}
      style={{ width: size, height: size, top: -3, left: -2 }}
    />
  );
}

SelectIcon.propTypes = {
  saving: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default SelectOption;
